export class BucketFilesSourceProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileFormat",
            "baseName": "fileFormat",
            "type": "FileFormat",
            "format": ""
        },
        {
            "name": "avroSchemaJson",
            "baseName": "avroSchemaJson",
            "type": "string",
            "format": ""
        },
        {
            "name": "csvOptions",
            "baseName": "csvOptions",
            "type": "CsvOptions",
            "format": ""
        },
        {
            "name": "mode",
            "baseName": "mode",
            "type": "BucketFilesMode",
            "format": ""
        },
        {
            "name": "pathGlob",
            "baseName": "pathGlob",
            "type": "string",
            "format": ""
        },
        {
            "name": "polling",
            "baseName": "polling",
            "type": "PollingConfig",
            "format": ""
        },
        {
            "name": "notificationEndpoint",
            "baseName": "notificationEndpoint",
            "type": "string",
            "format": ""
        },
        {
            "name": "notificationCredentialsSecretArn",
            "baseName": "notificationCredentialsSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "notificationMapping",
            "baseName": "notificationMapping",
            "type": "NotificationMessageMapping",
            "format": ""
        },
        {
            "name": "objectPathPartitionSpec",
            "baseName": "objectPathPartitionSpec",
            "type": "BucketPathPartitionSpec",
            "format": ""
        },
        {
            "name": "sourceShardByPathPartition",
            "baseName": "sourceShardByPathPartition",
            "type": "SourceShardByPathPartition",
            "format": ""
        },
        {
            "name": "partitionFields",
            "baseName": "partitionFields",
            "type": "Array<PartitionField>",
            "format": ""
        },
        {
            "name": "schemaOverrides",
            "baseName": "schemaOverrides",
            "type": "Array<FieldOverride>",
            "format": ""
        },
        {
            "name": "fetchConcurrency",
            "baseName": "fetchConcurrency",
            "type": "number",
            "format": ""
        },
        {
            "name": "pubsubAckDeadlineSeconds",
            "baseName": "pubsubAckDeadlineSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "flinkConfigOverrides",
            "baseName": "flinkConfigOverrides",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BucketFilesSourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
